import React, { useState, useRef } from "react";
import CustomLine from "./CustomLine";
import AppoinmentModal from "./AppoinmnetModal";

const ConsultBanner = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const stickyButtonRef = useRef(null);


    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    return (
        <div className="custom-science">
            <div className="custom-science custom-padding pt-80 pb-80 xl-screen-padding">
                <div className=" flex flex-col md:flex-row w-full">
                    <div className="w-full md:w-1/2 flex flex-col justify-center aboutmain">
                        <p className="custom-padding-bottom text-[#7C517E] text-md sm:text-md md:pt-20 font-lato block sm:flex items-center slide-left">
                            <CustomLine />
                            <span className="ml-0 sm:ml-2 text-p ">Nutrillion Consultation</span>
                        </p>
                        <h2 className="custom-padding-bottom text-lg sm:text-xl custom-line-height md:text-xl lg:text-4xl font-semibold text-black leading-tight client-text">
                            Personalized <span className="text-[#8f762c]">Nutrition</span> for Optimal Health
                        </h2>
                    </div>

                    <div className="w-full md:w-1/2 flex flex-col justify-center pt-80 ">
                        <p className="text-[#80888e] mb-6 text-p">
                            At Nutrillion, we take a science-driven, customized approach to nutrition, ensuring a transformative journey toward optimal health. Our consultation process is meticulously designed to decode your unique health profile, identify key concerns, and curate a precision-tailored nutrition strategy that evolves with your progress.
                        </p>
                        <div className="flex flex-row space-x-3">
                            <a href="https://wa.me/+919557439399" target="_blank" rel="noopener noreferrer">
                                <button className="bg-gray-800 common-btn-all-second text-white font-lato text-[10px] sm:text-sm md:text-[12px] px-3 py-1 sm:px-6 sm:py-2 md:px-6 md:py-3 rounded-full w-auto">
                                    Get Started
                                </button>
                            </a>
                            <button
                                onClick={openModal}

                                className="bg-[#8f762c] common-btn-all text-white font-lato text-[10px] sm:text-sm md:text-[12px] px-3 py-1 sm:px-6 sm:py-2 md:px-6 md:py-3 rounded-full w-auto"
                            >
                                Contact Us
                            </button>
                            <AppoinmentModal isOpen={isModalOpen} onClose={closeModal} />

                        </div>
                    </div>
                </div>
            </div>
            <div>
                <button
                    ref={stickyButtonRef}
                    type="button"
                    className="sticky-button bg-[#7c517e] text-white text-sm px-3 py-1 md:px-4 md:py-2 mt-2 md:mt-0 w-full cursor-pointer md:w-auto"
                    onClick={openModal}
                >
                    BOOK APPOINTMENT
                </button>

                <AppoinmentModal isOpen={isModalOpen} onClose={closeModal} />
            </div>
            <div className="flex flex-col custom-padding xl-screen-padding md:flex-row justify-between pt-20 pb-20 space-y-4 md:space-y-0 md:space-x-4">
                <div className="w-full md:w-1/3">
                    <img
                        src={require('../../src/assets/images/consultbanner1.png')}
                        alt="Image 1"
                        className="w-full h-auto object-cover"
                    />
                </div>
                <div className="w-full md:w-1/3">
                    <img
                        src={require('../../src/assets/images/consultbanner2.png')}
                        alt="Image 2"
                        className="w-full h-auto object-cover"
                    />
                </div>
                <div className="w-full md:w-1/3">
                    <img
                        src={require('../../src/assets/images/consultbanner3.png')}
                        alt="Image 3"
                        className="w-full h-auto object-cover"
                    />
                </div>
            </div>


        </div>
    );
};

export default ConsultBanner;
